import Vue from 'vue';
import creditNoteProductTransformer from './../../transformers/creditNoteProduct';
import all from './all';

const success = (data, id, resolve) => {
  all(id);
  resolve();
};

const failed = (errors, reject) => {
  reject(creditNoteProductTransformer.fetch(errors));
};

export default (id, creditNoteProduct) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/credit_notes/${id}/products`, creditNoteProductTransformer.send(creditNoteProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/store.js